/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CopilotTurnJobInfo } from "../../models/copilotTurnJobInfo.ts";

import type { DeleteV1DeleteExecutionSchedule200 } from "../../models/deleteV1DeleteExecutionSchedule200.ts";

import type { GraphExecutionJobInfo } from "../../models/graphExecutionJobInfo.ts";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { PausedScheduledChat } from "../../models/pausedScheduledChat.ts";

import type { ResumeScheduledChatResponse } from "../../models/resumeScheduledChatResponse.ts";

import type { ScheduleCreationRequest } from "../../models/scheduleCreationRequest.ts";

import type { ScheduleUpdateRequest } from "../../models/scheduleUpdateRequest.ts";

import type { ScheduledChatCadence } from "../../models/scheduledChatCadence.ts";

import type { SetScheduledChatCadenceRequest } from "../../models/setScheduledChatCadenceRequest.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getV1ListExecutionSchedulesForAGraphResponse200 = {
  data: GraphExecutionJobInfo[];
  status: 200;
};

export type getV1ListExecutionSchedulesForAGraphResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ListExecutionSchedulesForAGraphResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getV1ListExecutionSchedulesForAGraphResponseSuccess =
  getV1ListExecutionSchedulesForAGraphResponse200 & {
    headers: Headers;
  };
export type getV1ListExecutionSchedulesForAGraphResponseError = (
  | getV1ListExecutionSchedulesForAGraphResponse401
  | getV1ListExecutionSchedulesForAGraphResponse422
) & {
  headers: Headers;
};

export type getV1ListExecutionSchedulesForAGraphResponse =
  | getV1ListExecutionSchedulesForAGraphResponseSuccess
  | getV1ListExecutionSchedulesForAGraphResponseError;

export const getGetV1ListExecutionSchedulesForAGraphUrl = (graphId: string) => {
  return `/api/graphs/${graphId}/schedules`;
};

/**
 * @summary List execution schedules for a graph
 */
export const getV1ListExecutionSchedulesForAGraph = async (
  graphId: string,
  options?: RequestInit,
): Promise<getV1ListExecutionSchedulesForAGraphResponse> => {
  return customMutator<getV1ListExecutionSchedulesForAGraphResponse>(
    getGetV1ListExecutionSchedulesForAGraphUrl(graphId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListExecutionSchedulesForAGraphQueryKey = (
  graphId: string,
) => {
  return [`/api/graphs/${graphId}/schedules`] as const;
};

export const getGetV1ListExecutionSchedulesForAGraphQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetV1ListExecutionSchedulesForAGraphQueryKey(graphId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>
  > = ({ signal }) =>
    getV1ListExecutionSchedulesForAGraph(graphId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: graphId !== null && graphId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListExecutionSchedulesForAGraphQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>
>;
export type GetV1ListExecutionSchedulesForAGraphQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetV1ListExecutionSchedulesForAGraph<
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
          TError,
          Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListExecutionSchedulesForAGraph<
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
          TError,
          Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListExecutionSchedulesForAGraph<
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List execution schedules for a graph
 */

export function useGetV1ListExecutionSchedulesForAGraph<
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1ListExecutionSchedulesForAGraphQueryOptions(
    graphId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List execution schedules for a graph
 */
export const prefetchGetV1ListExecutionSchedulesForAGraphQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  graphId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAGraph>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1ListExecutionSchedulesForAGraphQueryOptions(
    graphId,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postV1CreateExecutionScheduleResponse200 = {
  data: GraphExecutionJobInfo;
  status: 200;
};

export type postV1CreateExecutionScheduleResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1CreateExecutionScheduleResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1CreateExecutionScheduleResponseSuccess =
  postV1CreateExecutionScheduleResponse200 & {
    headers: Headers;
  };
export type postV1CreateExecutionScheduleResponseError = (
  | postV1CreateExecutionScheduleResponse401
  | postV1CreateExecutionScheduleResponse422
) & {
  headers: Headers;
};

export type postV1CreateExecutionScheduleResponse =
  | postV1CreateExecutionScheduleResponseSuccess
  | postV1CreateExecutionScheduleResponseError;

export const getPostV1CreateExecutionScheduleUrl = (graphId: string) => {
  return `/api/graphs/${graphId}/schedules`;
};

/**
 * @summary Create execution schedule
 */
export const postV1CreateExecutionSchedule = async (
  graphId: string,
  scheduleCreationRequest: ScheduleCreationRequest,
  options?: RequestInit,
): Promise<postV1CreateExecutionScheduleResponse> => {
  return customMutator<postV1CreateExecutionScheduleResponse>(
    getPostV1CreateExecutionScheduleUrl(graphId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(scheduleCreationRequest),
    },
  );
};

export const getPostV1CreateExecutionScheduleMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CreateExecutionSchedule>>,
    TError,
    { graphId: string; data: ScheduleCreationRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CreateExecutionSchedule>>,
  TError,
  { graphId: string; data: ScheduleCreationRequest },
  TContext
> => {
  const mutationKey = ["postV1CreateExecutionSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CreateExecutionSchedule>>,
    { graphId: string; data: ScheduleCreationRequest }
  > = (props) => {
    const { graphId, data } = props ?? {};

    return postV1CreateExecutionSchedule(graphId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CreateExecutionScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CreateExecutionSchedule>>
>;
export type PostV1CreateExecutionScheduleMutationBody = ScheduleCreationRequest;
export type PostV1CreateExecutionScheduleMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Create execution schedule
 */
export const usePostV1CreateExecutionSchedule = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CreateExecutionSchedule>>,
      TError,
      { graphId: string; data: ScheduleCreationRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CreateExecutionSchedule>>,
  TError,
  { graphId: string; data: ScheduleCreationRequest },
  TContext
> => {
  return useMutation(
    getPostV1CreateExecutionScheduleMutationOptions(options),
    queryClient,
  );
};
export type getV1ListExecutionSchedulesForAUserResponse200 = {
  data: GraphExecutionJobInfo[];
  status: 200;
};

export type getV1ListExecutionSchedulesForAUserResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1ListExecutionSchedulesForAUserResponseSuccess =
  getV1ListExecutionSchedulesForAUserResponse200 & {
    headers: Headers;
  };
export type getV1ListExecutionSchedulesForAUserResponseError =
  getV1ListExecutionSchedulesForAUserResponse401 & {
    headers: Headers;
  };

export type getV1ListExecutionSchedulesForAUserResponse =
  | getV1ListExecutionSchedulesForAUserResponseSuccess
  | getV1ListExecutionSchedulesForAUserResponseError;

export const getGetV1ListExecutionSchedulesForAUserUrl = () => {
  return `/api/schedules`;
};

/**
 * @summary List execution schedules for a user
 */
export const getV1ListExecutionSchedulesForAUser = async (
  options?: RequestInit,
): Promise<getV1ListExecutionSchedulesForAUserResponse> => {
  return customMutator<getV1ListExecutionSchedulesForAUserResponse>(
    getGetV1ListExecutionSchedulesForAUserUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1ListExecutionSchedulesForAUserQueryKey = () => {
  return [`/api/schedules`] as const;
};

export const getGetV1ListExecutionSchedulesForAUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1ListExecutionSchedulesForAUserQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>
  > = ({ signal }) =>
    getV1ListExecutionSchedulesForAUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1ListExecutionSchedulesForAUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>
>;
export type GetV1ListExecutionSchedulesForAUserQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1ListExecutionSchedulesForAUser<
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
          TError,
          Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListExecutionSchedulesForAUser<
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
          TError,
          Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1ListExecutionSchedulesForAUser<
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List execution schedules for a user
 */

export function useGetV1ListExecutionSchedulesForAUser<
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetV1ListExecutionSchedulesForAUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List execution schedules for a user
 */
export const prefetchGetV1ListExecutionSchedulesForAUserQuery = async <
  TData = Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1ListExecutionSchedulesForAUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions =
    getGetV1ListExecutionSchedulesForAUserQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type listCopilotFollowupSchedulesResponse200 = {
  data: CopilotTurnJobInfo[];
  status: 200;
};

export type listCopilotFollowupSchedulesResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listCopilotFollowupSchedulesResponseSuccess =
  listCopilotFollowupSchedulesResponse200 & {
    headers: Headers;
  };
export type listCopilotFollowupSchedulesResponseError =
  listCopilotFollowupSchedulesResponse401 & {
    headers: Headers;
  };

export type listCopilotFollowupSchedulesResponse =
  | listCopilotFollowupSchedulesResponseSuccess
  | listCopilotFollowupSchedulesResponseError;

export const getListCopilotFollowupSchedulesUrl = () => {
  return `/api/schedules/followups`;
};

/**
 * Return only copilot-turn schedules for the current user.
 *
 * Sibling of :func:`list_all_graphs_execution_schedules`; one route per kind
 * keeps the generated frontend client typed to a single concrete return type
 * instead of a discriminated union.
 * @summary List copilot follow-up schedules for a user
 */
export const listCopilotFollowupSchedules = async (
  options?: RequestInit,
): Promise<listCopilotFollowupSchedulesResponse> => {
  return customMutator<listCopilotFollowupSchedulesResponse>(
    getListCopilotFollowupSchedulesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCopilotFollowupSchedulesQueryKey = () => {
  return [`/api/schedules/followups`] as const;
};

export const getListCopilotFollowupSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCopilotFollowupSchedulesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCopilotFollowupSchedules>>
  > = ({ signal }) =>
    listCopilotFollowupSchedules({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCopilotFollowupSchedulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCopilotFollowupSchedules>>
>;
export type ListCopilotFollowupSchedulesQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useListCopilotFollowupSchedules<
  TData = Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
          TError,
          Awaited<ReturnType<typeof listCopilotFollowupSchedules>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCopilotFollowupSchedules<
  TData = Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
          TError,
          Awaited<ReturnType<typeof listCopilotFollowupSchedules>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCopilotFollowupSchedules<
  TData = Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List copilot follow-up schedules for a user
 */

export function useListCopilotFollowupSchedules<
  TData = Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCopilotFollowupSchedulesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List copilot follow-up schedules for a user
 */
export const prefetchListCopilotFollowupSchedulesQuery = async <
  TData = Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCopilotFollowupSchedules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListCopilotFollowupSchedulesQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type listPausedScheduledChatsResponse200 = {
  data: PausedScheduledChat[];
  status: 200;
};

export type listPausedScheduledChatsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type listPausedScheduledChatsResponseSuccess =
  listPausedScheduledChatsResponse200 & {
    headers: Headers;
  };
export type listPausedScheduledChatsResponseError =
  listPausedScheduledChatsResponse401 & {
    headers: Headers;
  };

export type listPausedScheduledChatsResponse =
  | listPausedScheduledChatsResponseSuccess
  | listPausedScheduledChatsResponseError;

export const getListPausedScheduledChatsUrl = () => {
  return `/api/schedules/followups/paused`;
};

/**
 * A paused job drops out of the follow-ups list above, so the chats a
 * failure streak paused are listed here, each once however many fire times
 * it has, with why and what Resume takes.
 * @summary List scheduled chats paused after failing the same way
 */
export const listPausedScheduledChats = async (
  options?: RequestInit,
): Promise<listPausedScheduledChatsResponse> => {
  return customMutator<listPausedScheduledChatsResponse>(
    getListPausedScheduledChatsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPausedScheduledChatsQueryKey = () => {
  return [`/api/schedules/followups/paused`] as const;
};

export const getListPausedScheduledChatsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPausedScheduledChats>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listPausedScheduledChats>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPausedScheduledChatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPausedScheduledChats>>
  > = ({ signal }) => listPausedScheduledChats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPausedScheduledChats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPausedScheduledChatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPausedScheduledChats>>
>;
export type ListPausedScheduledChatsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useListPausedScheduledChats<
  TData = Awaited<ReturnType<typeof listPausedScheduledChats>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPausedScheduledChats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPausedScheduledChats>>,
          TError,
          Awaited<ReturnType<typeof listPausedScheduledChats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPausedScheduledChats<
  TData = Awaited<ReturnType<typeof listPausedScheduledChats>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPausedScheduledChats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPausedScheduledChats>>,
          TError,
          Awaited<ReturnType<typeof listPausedScheduledChats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPausedScheduledChats<
  TData = Awaited<ReturnType<typeof listPausedScheduledChats>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPausedScheduledChats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List scheduled chats paused after failing the same way
 */

export function useListPausedScheduledChats<
  TData = Awaited<ReturnType<typeof listPausedScheduledChats>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPausedScheduledChats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListPausedScheduledChatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List scheduled chats paused after failing the same way
 */
export const prefetchListPausedScheduledChatsQuery = async <
  TData = Awaited<ReturnType<typeof listPausedScheduledChats>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPausedScheduledChats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListPausedScheduledChatsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type getScheduledChatCadenceResponse200 = {
  data: ScheduledChatCadence;
  status: 200;
};

export type getScheduledChatCadenceResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getScheduledChatCadenceResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getScheduledChatCadenceResponseSuccess =
  getScheduledChatCadenceResponse200 & {
    headers: Headers;
  };
export type getScheduledChatCadenceResponseError = (
  | getScheduledChatCadenceResponse401
  | getScheduledChatCadenceResponse422
) & {
  headers: Headers;
};

export type getScheduledChatCadenceResponse =
  | getScheduledChatCadenceResponseSuccess
  | getScheduledChatCadenceResponseError;

export const getGetScheduledChatCadenceUrl = (scheduleKey: string) => {
  return `/api/schedules/followups/${scheduleKey}/cadence`;
};

/**
 * @summary How often a scheduled chat runs, and how it could run less often
 */
export const getScheduledChatCadence = async (
  scheduleKey: string,
  options?: RequestInit,
): Promise<getScheduledChatCadenceResponse> => {
  return customMutator<getScheduledChatCadenceResponse>(
    getGetScheduledChatCadenceUrl(scheduleKey),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetScheduledChatCadenceQueryKey = (scheduleKey: string) => {
  return [`/api/schedules/followups/${scheduleKey}/cadence`] as const;
};

export const getGetScheduledChatCadenceQueryOptions = <
  TData = Awaited<ReturnType<typeof getScheduledChatCadence>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  scheduleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledChatCadence>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetScheduledChatCadenceQueryKey(scheduleKey);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getScheduledChatCadence>>
  > = ({ signal }) =>
    getScheduledChatCadence(scheduleKey, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: scheduleKey !== null && scheduleKey !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getScheduledChatCadence>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetScheduledChatCadenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getScheduledChatCadence>>
>;
export type GetScheduledChatCadenceQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetScheduledChatCadence<
  TData = Awaited<ReturnType<typeof getScheduledChatCadence>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  scheduleKey: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledChatCadence>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduledChatCadence>>,
          TError,
          Awaited<ReturnType<typeof getScheduledChatCadence>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScheduledChatCadence<
  TData = Awaited<ReturnType<typeof getScheduledChatCadence>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  scheduleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledChatCadence>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduledChatCadence>>,
          TError,
          Awaited<ReturnType<typeof getScheduledChatCadence>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScheduledChatCadence<
  TData = Awaited<ReturnType<typeof getScheduledChatCadence>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  scheduleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledChatCadence>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary How often a scheduled chat runs, and how it could run less often
 */

export function useGetScheduledChatCadence<
  TData = Awaited<ReturnType<typeof getScheduledChatCadence>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  scheduleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledChatCadence>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetScheduledChatCadenceQueryOptions(
    scheduleKey,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary How often a scheduled chat runs, and how it could run less often
 */
export const prefetchGetScheduledChatCadenceQuery = async <
  TData = Awaited<ReturnType<typeof getScheduledChatCadence>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  scheduleKey: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getScheduledChatCadence>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetScheduledChatCadenceQueryOptions(
    scheduleKey,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type setScheduledChatCadenceResponse200 = {
  data: ScheduledChatCadence;
  status: 200;
};

export type setScheduledChatCadenceResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type setScheduledChatCadenceResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type setScheduledChatCadenceResponseSuccess =
  setScheduledChatCadenceResponse200 & {
    headers: Headers;
  };
export type setScheduledChatCadenceResponseError = (
  | setScheduledChatCadenceResponse401
  | setScheduledChatCadenceResponse422
) & {
  headers: Headers;
};

export type setScheduledChatCadenceResponse =
  | setScheduledChatCadenceResponseSuccess
  | setScheduledChatCadenceResponseError;

export const getSetScheduledChatCadenceUrl = (scheduleKey: string) => {
  return `/api/schedules/followups/${scheduleKey}/cadence`;
};

/**
 * @summary Run a scheduled chat less often
 */
export const setScheduledChatCadence = async (
  scheduleKey: string,
  setScheduledChatCadenceRequest: SetScheduledChatCadenceRequest,
  options?: RequestInit,
): Promise<setScheduledChatCadenceResponse> => {
  return customMutator<setScheduledChatCadenceResponse>(
    getSetScheduledChatCadenceUrl(scheduleKey),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setScheduledChatCadenceRequest),
    },
  );
};

export const getSetScheduledChatCadenceMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setScheduledChatCadence>>,
    TError,
    { scheduleKey: string; data: SetScheduledChatCadenceRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setScheduledChatCadence>>,
  TError,
  { scheduleKey: string; data: SetScheduledChatCadenceRequest },
  TContext
> => {
  const mutationKey = ["setScheduledChatCadence"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setScheduledChatCadence>>,
    { scheduleKey: string; data: SetScheduledChatCadenceRequest }
  > = (props) => {
    const { scheduleKey, data } = props ?? {};

    return setScheduledChatCadence(scheduleKey, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetScheduledChatCadenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof setScheduledChatCadence>>
>;
export type SetScheduledChatCadenceMutationBody =
  SetScheduledChatCadenceRequest;
export type SetScheduledChatCadenceMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Run a scheduled chat less often
 */
export const useSetScheduledChatCadence = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setScheduledChatCadence>>,
      TError,
      { scheduleKey: string; data: SetScheduledChatCadenceRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setScheduledChatCadence>>,
  TError,
  { scheduleKey: string; data: SetScheduledChatCadenceRequest },
  TContext
> => {
  return useMutation(
    getSetScheduledChatCadenceMutationOptions(options),
    queryClient,
  );
};
export type resumeScheduledChatResponse200 = {
  data: ResumeScheduledChatResponse;
  status: 200;
};

export type resumeScheduledChatResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type resumeScheduledChatResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type resumeScheduledChatResponseSuccess =
  resumeScheduledChatResponse200 & {
    headers: Headers;
  };
export type resumeScheduledChatResponseError = (
  | resumeScheduledChatResponse401
  | resumeScheduledChatResponse422
) & {
  headers: Headers;
};

export type resumeScheduledChatResponse =
  | resumeScheduledChatResponseSuccess
  | resumeScheduledChatResponseError;

export const getResumeScheduledChatUrl = (scheduleKey: string) => {
  return `/api/schedules/followups/${scheduleKey}/resume`;
};

/**
 * @summary Resume a scheduled chat paused after failing the same way
 */
export const resumeScheduledChat = async (
  scheduleKey: string,
  options?: RequestInit,
): Promise<resumeScheduledChatResponse> => {
  return customMutator<resumeScheduledChatResponse>(
    getResumeScheduledChatUrl(scheduleKey),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getResumeScheduledChatMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeScheduledChat>>,
    TError,
    { scheduleKey: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeScheduledChat>>,
  TError,
  { scheduleKey: string },
  TContext
> => {
  const mutationKey = ["resumeScheduledChat"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeScheduledChat>>,
    { scheduleKey: string }
  > = (props) => {
    const { scheduleKey } = props ?? {};

    return resumeScheduledChat(scheduleKey, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeScheduledChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeScheduledChat>>
>;

export type ResumeScheduledChatMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Resume a scheduled chat paused after failing the same way
 */
export const useResumeScheduledChat = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resumeScheduledChat>>,
      TError,
      { scheduleKey: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resumeScheduledChat>>,
  TError,
  { scheduleKey: string },
  TContext
> => {
  return useMutation(
    getResumeScheduledChatMutationOptions(options),
    queryClient,
  );
};
export type deleteV1DeleteExecutionScheduleResponse200 = {
  data: DeleteV1DeleteExecutionSchedule200;
  status: 200;
};

export type deleteV1DeleteExecutionScheduleResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type deleteV1DeleteExecutionScheduleResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteV1DeleteExecutionScheduleResponseSuccess =
  deleteV1DeleteExecutionScheduleResponse200 & {
    headers: Headers;
  };
export type deleteV1DeleteExecutionScheduleResponseError = (
  | deleteV1DeleteExecutionScheduleResponse401
  | deleteV1DeleteExecutionScheduleResponse422
) & {
  headers: Headers;
};

export type deleteV1DeleteExecutionScheduleResponse =
  | deleteV1DeleteExecutionScheduleResponseSuccess
  | deleteV1DeleteExecutionScheduleResponseError;

export const getDeleteV1DeleteExecutionScheduleUrl = (scheduleId: string) => {
  return `/api/schedules/${scheduleId}`;
};

/**
 * @summary Delete execution schedule
 */
export const deleteV1DeleteExecutionSchedule = async (
  scheduleId: string,
  options?: RequestInit,
): Promise<deleteV1DeleteExecutionScheduleResponse> => {
  return customMutator<deleteV1DeleteExecutionScheduleResponse>(
    getDeleteV1DeleteExecutionScheduleUrl(scheduleId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteV1DeleteExecutionScheduleMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1DeleteExecutionSchedule>>,
    TError,
    { scheduleId: string },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV1DeleteExecutionSchedule>>,
  TError,
  { scheduleId: string },
  TContext
> => {
  const mutationKey = ["deleteV1DeleteExecutionSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV1DeleteExecutionSchedule>>,
    { scheduleId: string }
  > = (props) => {
    const { scheduleId } = props ?? {};

    return deleteV1DeleteExecutionSchedule(scheduleId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV1DeleteExecutionScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV1DeleteExecutionSchedule>>
>;

export type DeleteV1DeleteExecutionScheduleMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Delete execution schedule
 */
export const useDeleteV1DeleteExecutionSchedule = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV1DeleteExecutionSchedule>>,
      TError,
      { scheduleId: string },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteV1DeleteExecutionSchedule>>,
  TError,
  { scheduleId: string },
  TContext
> => {
  return useMutation(
    getDeleteV1DeleteExecutionScheduleMutationOptions(options),
    queryClient,
  );
};
export type patchV1UpdateExecutionScheduleResponse200 = {
  data: GraphExecutionJobInfo;
  status: 200;
};

export type patchV1UpdateExecutionScheduleResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type patchV1UpdateExecutionScheduleResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type patchV1UpdateExecutionScheduleResponseSuccess =
  patchV1UpdateExecutionScheduleResponse200 & {
    headers: Headers;
  };
export type patchV1UpdateExecutionScheduleResponseError = (
  | patchV1UpdateExecutionScheduleResponse401
  | patchV1UpdateExecutionScheduleResponse422
) & {
  headers: Headers;
};

export type patchV1UpdateExecutionScheduleResponse =
  | patchV1UpdateExecutionScheduleResponseSuccess
  | patchV1UpdateExecutionScheduleResponseError;

export const getPatchV1UpdateExecutionScheduleUrl = (scheduleId: string) => {
  return `/api/schedules/${scheduleId}`;
};

/**
 * Change an agent schedule's name, timing or inputs. Only the schedule's
 * owner can edit it; anyone else gets the same 404 as a missing schedule.
 * @summary Update execution schedule
 */
export const patchV1UpdateExecutionSchedule = async (
  scheduleId: string,
  scheduleUpdateRequest: ScheduleUpdateRequest,
  options?: RequestInit,
): Promise<patchV1UpdateExecutionScheduleResponse> => {
  return customMutator<patchV1UpdateExecutionScheduleResponse>(
    getPatchV1UpdateExecutionScheduleUrl(scheduleId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(scheduleUpdateRequest),
    },
  );
};

export const getPatchV1UpdateExecutionScheduleMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1UpdateExecutionSchedule>>,
    TError,
    { scheduleId: string; data: ScheduleUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1UpdateExecutionSchedule>>,
  TError,
  { scheduleId: string; data: ScheduleUpdateRequest },
  TContext
> => {
  const mutationKey = ["patchV1UpdateExecutionSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1UpdateExecutionSchedule>>,
    { scheduleId: string; data: ScheduleUpdateRequest }
  > = (props) => {
    const { scheduleId, data } = props ?? {};

    return patchV1UpdateExecutionSchedule(scheduleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1UpdateExecutionScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1UpdateExecutionSchedule>>
>;
export type PatchV1UpdateExecutionScheduleMutationBody = ScheduleUpdateRequest;
export type PatchV1UpdateExecutionScheduleMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update execution schedule
 */
export const usePatchV1UpdateExecutionSchedule = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1UpdateExecutionSchedule>>,
      TError,
      { scheduleId: string; data: ScheduleUpdateRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV1UpdateExecutionSchedule>>,
  TError,
  { scheduleId: string; data: ScheduleUpdateRequest },
  TContext
> => {
  return useMutation(
    getPatchV1UpdateExecutionScheduleMutationOptions(options),
    queryClient,
  );
};
